// extracted by mini-css-extract-plugin
export var billingAddress = "_qx-g";
export var contactInfo = "_qx-d";
export var customerInfoContainer = "_qx-c";
export var customerInfoContainerMobile = "_qx-h";
export var customerInfoRow = "_qx-a";
export var customerInfoSection = "_qx-b";
export var fullWidthDividerMobile = "_qx-i";
export var imageContainer = "_qx-1";
export var paymentMethod = "_qx-e";
export var priceText = "_qx-6";
export var priceTextMobile = "_qx-7";
export var product = "_qx-0";
export var productImage = "_qx-2";
export var productInfo = "_qx-4";
export var productMobile = "_qx-9";
export var productTitle = "_qx-8";
export var quantityBadge = "_qx-3";
export var quantityText = "_qx-5";
export var shippingAddress = "_qx-f";